<template>
  <div class="span-10-lg offset-3-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs" v-bind:class="popup_border">
    <div class="notification-content">
      <div class="notification-svg hide-sm"><component v-bind:is="is_correct"></component></div>
      <div class="notification-text">
        <div class="notification-svg-mobile show-sm notification-svg-sm"><component v-bind:is="is_correct"></component></div>
        <p class="subheader upcase">{{title}}</p>
        <p><slot></slot></p>
      </div>
    </div>
  </div>
</template>

<script>
  import svg from '../svg'

  export default {
    props: ['type', 'title'],
    components: {
      ...svg
    },
    // data () {
    //   return {
    //     correct_text: "you've got it!",
    //     incorrect_text: "not quite."
    //   }
    // },
    computed: {
      // title () {
      //   if (this.type === 'correct') {
      //     return this.correct_text
      //   }
      //   return this.incorrect_text
      // },
      popup_border () {
        if (this.is_correct === 'correct') {
          return 'border-green'
        }
        return 'border-red'
      },
      is_correct () {
        return this.$store.state.checkbox.correct
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../../styles/variables';

  //- notification popup -//

  .notification-content {
    position: relative;
    display: flex;
    align-content: center;
    padding: 48px;
    background: $white;
    cursor: pointer;
  }

  .notification-svg {
    position: relative;
    margin: auto;
    margin-right: 48px;
  }

  .notification-svg-mobile {
    position: relative;
    display: inline-block;
    margin-right: 12px;
  }
  
  .notification-text {
    position: relative;
    margin: auto;
    @media screen and (max-width: $sm-max) {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      p, .p, {
        margin: 6px;
      }
    }
  }
</style>

<style lang="scss">
  // resize notification svg
  .notification-svg-sm {
    svg {
      height: 24px;
      width: 24px;
    }
  }
</style>


// WEBPACK FOOTER //
// popup_notification.vue?1a36d234